"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViewDerivateGallery = void 0;
const datasheet_1 = require("../../modules/database/store/selectors/resource/datasheet");
const field_1 = require("../../model/field");
const view_derivate_base_1 = require("./view_derivate_base");
class ViewDerivateGallery extends view_derivate_base_1.ViewDerivateBase {
    constructor(state, datasheetId) {
        super(state, datasheetId);
        this.state = state;
        this.datasheetId = datasheetId;
    }
    getGalleryGroupedRows(view, rows) {
        var _a, _b;
        const state = this.state;
        const datasheetId = this.datasheetId;
        const groupInfo = view.groupInfo || [];
        const groupedRows = [];
        const snapshot = (_b = (_a = this.state.datasheetMap[this.datasheetId]) === null || _a === void 0 ? void 0 : _a.datasheet) === null || _b === void 0 ? void 0 : _b.snapshot;
        if (!groupInfo || !datasheetId || !snapshot) {
            return groupedRows;
        }
        if (groupInfo && groupInfo.length === 0) {
            return groupedRows;
        }
        const fieldMap = (0, datasheet_1.getFieldMap)(state, datasheetId);
        const fieldId = groupInfo[0].fieldId;
        const field = fieldMap[fieldId];
        let preRecordId = '';
        let tempGroupedRows = [];
        for (let index = 0; index < rows.length; index++) {
            const record = rows[index];
            const recordId = record.recordId;
            if (index === 0) {
                tempGroupedRows.push(record.recordId);
            }
            else {
                if (field &&
                    field_1.Field.bindContext(field, state).compare((0, datasheet_1.getCellValue)(state, snapshot, preRecordId, fieldId), (0, datasheet_1.getCellValue)(state, snapshot, recordId, fieldId))) {
                    groupedRows.push(tempGroupedRows);
                    tempGroupedRows = [record.recordId];
                }
                else {
                    tempGroupedRows.push(record.recordId);
                }
            }
            preRecordId = recordId;
            if (index === rows.length - 1) {
                groupedRows.push(tempGroupedRows);
                break;
            }
        }
        return groupedRows;
    }
    getViewDerivation(view) {
        const baseViewDerivation = super.getViewDerivation(view);
        const galleryGroupedRows = this.getGalleryGroupedRows(view, baseViewDerivation.visibleRows);
        return Object.assign(Object.assign({}, baseViewDerivation), { 
            // Grouped rows of data for gallery view.
            galleryGroupedRows });
    }
    /**
     * Get computationally derived data containing search results.
     *
     * Used to do calculations when searching for updates.
     */
    getViewDerivationWithSearch(view, rowsWithoutSearch) {
        const baseViewDerivation = super.getViewDerivationWithSearch(view, rowsWithoutSearch);
        const galleryGroupedRows = this.getGalleryGroupedRows(view, baseViewDerivation.visibleRows);
        return Object.assign(Object.assign({}, baseViewDerivation), { 
            // Grouped rows of data for gallery view
            galleryGroupedRows });
    }
}
exports.ViewDerivateGallery = ViewDerivateGallery;
//# sourceMappingURL=view_derivate_gallery.js.map